export default {
  common: {
    home: '首页',
    about: '关于我们',
    services: '产品服务',
    contact: '联系我们',
    company: '公司介绍',
    technical: '技术服务'
  },
  header: {
    navigation: '导航菜单',
    language: '语言'
  },
  footer: {
    copyright: '版权所有',
    reserved: '保留所有权利',
    companyIntro: '公司介绍',
    companyCulture: '公司文化',
    companyVision: '公司愿景',
    businessPhilosophy: '经营理念',
    developmentHistory: '发展历程',
    qualifications: '资质荣誉',
    partners: '合作伙伴',
    serviceAreas: '服务领域',
    uavService: '无人机服务',
    remoteSensing: '遥感数据服务',
    modeling3d: '三维数字化建模服务',
    visualization3d: '三维可视化服务',
    animation3d: '三维动画服务',
    systemIntegration: '系统集成服务',
    contactUs: '联系我们',
    handanCenter: '邯郸生产中心: 0310-5300963',
    handanAddress: '地址：河北省邯郸市丛台区荀子大街5号',
    wuanCenter: '武安科技中心: 19930806111',
    wuanAddress: '地址: 河北省邯郸市武安市工业园区纬三路创业服务中心四期4号楼第6层',
    officialWechat: '官方微信公众号',
    officialDouyin: '官方抖音号',
    copyrightNotice: '版权说明Copyright © 2022 河北高翔地理信息技术服务有限公司'
  },
  home: {
    welcome: '欢迎来到我们的网站',
    introduction: '我们是一家专业的地理信息服务公司'
  },
  productService: {
    title: '技术服务',
    titleEnglish: 'Technical Services',
    productTitle: '产品服务',
    productTitleEnglish: 'Product Service',
    services: ['无人机服务', '遥感数据服务', '三维数字化建模服务', '三维可视化服务', '三维动画服务', '系统集成'],
    productServices: ['软件产品', '硬件产品']
  },
  aboutUs: {
    title: '关于我们',
    titleEnglish: 'About Us',
    content: '河北高翔地理信息技术服务有限公司创立于2015年11月，是一家深耕地理信息领域，兼具技术与产品服务能力的综合性高新技术企业。公司以地理信息为核心，构建"数据获取—处理分析—应用开发"全链条技术服务体系，提供无人机应用及培训、航空摄影测量、实景三维建模、GIS系统定制开发等服务，为自然资源、智慧城市、农林水利、应急管理等领域提供一站式解决方案。同时，公司自主研发高端智能装备，主营穿越机、自动化机场及无人机反制设备，产品广泛应用于测绘勘探、安防巡检、应急救援、低空防护等场景，以稳定性能与定制化方案为各行业提供高性能硬件支撑。'
  },
  companyIntroduction: {
    title: '公司介绍',
    titleEnglish: 'Enterprise introduction',
    description: '河北高翔地理信息技术服务有限公司创立于2015年11月，是一家深耕地理信息领域，兼具技术与产品服务能力的综合性高新技术企业。公司以地理信息为核心，构建"数据获取—处理分析—应用开发"全链条技术服务体系，提供无人机应用及培训、航空摄影测量、实景三维建模、GIS系统定制开发等服务，为自然资源、智慧城市、农林水利、应急管理等领域提供一站式解决方案。同时，公司自主研发高端智能装备，主营穿越机、自动化机场及无人机反制装备，产品广泛应用于测绘勘探、安防巡检、应急救援、低空防护等场景，以稳定性能与定制化方案为各行业提供高性能硬件支撑。',
    companyCulture: {
      title: '企业文化',
      content: '一家人，一个梦，一直拼，一直赢'
    },
    businessPhilosophy: {
      title: '经营理念',
      content: '人才兴企，科技强企，质量立企，制度管企'
    },
    companyVision: {
      title: '企业愿景',
      content: '成为行业领先的测绘与地理信息服务供应商'
    },
    companySpirit: {
      title: '企业精神',
      content: '共生、共建、共享',
      contentLeft: '聚心、聚力、聚智、聚能'
    },
    qualifications: {
      title: '资质荣誉',
      titleEnglish: 'Qualifications and honors',
      statistics: [
        { title: '资质证书', key: 'qualifications' },
        { title: '专利软著', key: 'patents' },
        { title: '项目奖项', key: 'awards' },
        { title: '社会性荣誉', key: 'honors' }
      ]
    },
    developmentHistory: {
      title: '发展历程',
      titleEnglish: 'Development history'
    },
    partners: {
      title: '合作伙伴',
      titleEnglish: 'Cooperation Partner'
    }
  },
  productServiceTab: {
    tabs: [
      { title: '无人机服务', name: 'UAVService', iconClass: 'i-css iconfont icon-gx-airplane' },
      { title: '遥感数据服务', name: 'RemoteSensingData', iconClass: 'i-css iconfont icon-gx-airdrop' },
      { title: '三维数字化建模服务', name: 'UAVTraining', iconClass: 'i-css iconfont icon-gx-buildings' },
      { title: '三维可视化服务', name: 'Visualization', iconClass: 'i-css iconfont icon-gx-a-3d-cube-scan' },
      { title: '三维动画服务', name: 'SurveyingServices', iconClass: 'i-css iconfont icon-gx-global-edit' },
      { title: '系统集成服务', name: 'systemIntegration', iconClass: 'i-css iconfont icon-gx-format-square' }
    ],
    moduleTitle: '测绘工程'
  },
  productDisplay: {
    softwareProducts: '软件产品',
    hardwareProducts: '硬件产品',
    vmap: {
      name: 'Vmap（河北）',
      tagline: '面向孪生城市的基础数字化底座',
      features: {
        dataAsset: { title: '数据资产汇聚', desc: '汇聚矢量、影像数据资源' },
        historyImage: { title: '历史影像追溯', desc: '支持2018-2025年历年影像整合' },
        customizedRelease: { title: '定制化数据发布', desc: '支持区域数据定制化发布' },
        vectorTools: { title: '矢量生产工具', desc: '提供专业矢量标绘工具' },
        openApi: { title: '开放API能力', desc: '开放POI接口，支持二次开发' }
      }
    },
    uavControl: {
      name: '无人机控制平台',
      tagline: '面向无人机巡查的智能管控平台',
      features: {
        deviceManagement: { title: '设备智能管理', desc: '实时监控参数，生成健康报告' },
        routePlanning: { title: '智能航线规划', desc: '人工+算法，模拟优化飞行计划' },
        flightMonitoring: { title: '实时飞行监控', desc: '多维度预警与应急处理' },
        obstacleAvoidance: { title: '智能标注避障', desc: '自动识别障碍物并执行避让' },
        resultManagement: { title: '成果管理共享', desc: '集中存储，关键词检索，在线分析' }
      }
    },
    spatioTemporalData: {
      name: '时空数据资产管理平台',
      tagline: '面向数据资产的智能管理与分析平台',
      features: {
        dataIntegration: { title: '数据整合分析', desc: '打破数据孤岛，实现无缝衔接' },
        massDataManagement: { title: '海量数据管理', desc: '高效管理三维模型、激光点云等数据' },
        standardizedSharing: { title: '标准化数据共享', desc: '统一格式接口，链接+密码安全调用' },
        autoProcessing: { title: '自动化数据处理', desc: '影像拼接、合成、三维重建自动化' }
      }
    },
    hardware: {
      portableJammer: {
        name: '便携式干扰枪',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        collapseParams: '收起参数',
        expandParams: '核心参数',
        intro: '便携式干扰枪可远程阻断遥控信号，强制无人机着陆或返航，确保低空安全，剥夺遥控者视图与定位的能力，实现精准管制。',
        params: {
          powerSupply: '一次充电稳定工作3天，外置充电器',
          interceptionMode: '强制驱离、迫降、图传干扰',
          interceptionChannel: '四通道',
          controlDistance: '≥1500米（空旷无电磁干扰）',
          supportedBands: '1560-1620MHz / 2400-2500MHz / 5725-5850MHz / 900-930MHz'
        },
        labels: {
          powerSupply: '供电',
          interceptionMode: '拦截方式',
          interceptionChannel: '拦截通道',
          controlDistance: '管制距离',
          supportedBands: '支持频段'
        }
      },
      photoelectricTracking: {
        name: '光电跟踪设备',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        collapseParams: '收起参数',
        expandParams: '核心参数',
        intro: '光电跟踪设备利用无线电或雷达导引，捕捉并处理无人机的光学或红外影像，昼夜连续追踪，具有优异的低空跟踪性能，高精度，实时记录目标视频与图片信息。',
        params: {
          rotationRange: '方位0°~360°，俯仰-45°~90°',
          trackingDistance: '白天3km / 夜间2km',
          positioningAccuracy: '±0.2°',
          workingTemp: '-40℃ ~ +70℃'
        },
        labels: {
          rotationRange: '转动范围',
          trackingDistance: '跟踪距离',
          positioningAccuracy: '定位精度',
          workingTemp: '工作温度'
        }
      },
      radarDetection: {
        name: '雷达探测设备',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        collapseParams: '收起参数',
        expandParams: '核心参数',
        intro: '雷达探测设备含雷达阵面、机械转台及电源组件，专用于边境、机场等地的小型无人机监测，精确获取目标位置、距离、高度及移动速度信息。',
        params: {
          workingBand: 'X波段',
          detectionDistance: '无人机5km / 行人8km / 车辆10km',
          azimuthCoverage: '360°',
          workingTemp: '-40℃ ~ +55℃'
        },
        labels: {
          workingBand: '工作频段',
          detectionDistance: '探测距离',
          azimuthCoverage: '方位覆盖',
          workingTemp: '工作温度'
        }
      },
      fullBandDevice: {
        name: '全频段察打诱一体设备',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        collapseParams: '收起参数',
        expandParams: '核心参数',
        intro: '全频段察打诱一体设备集电子扫描与侦扰功能，涵盖天线阵列、功放及信号处理器件，实现对低速无人机的自主侦测、干扰与诱骗。',
        params: {
          wirelessDetectionDistance: '≥6km',
          linkJammingDistance: '5km（干通比>10:1）',
          droneIdentificationTypes: '≥200种',
          timeAccuracy: '<30ns'
        },
        labels: {
          wirelessDetectionDistance: '无线侦测距离',
          linkJammingDistance: '链路干扰距离',
          droneIdentificationTypes: '无人机识别种类',
          timeAccuracy: '时间精度'
        }
      },
      fixedDevice: {
        name: '固定式侦打一体设备',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        collapseParams: '收起参数',
        expandParams: '核心参数',
        intro: '固定式侦打一体设备具备远程切断操控信号的能力，能够强制目标无人机执行着陆或者返航指令，同时可剥夺遥控者对无人机的视图获取以及定位操控权限，达成对无人机的精准化管制。',
        params: {
          detectionDistance: '1.5-4KM（视天线而定）',
          detectionTime: '≤2秒（随无人机距离变化）',
          jammingBands: '900MHz，GPS，2.4GHz，5.8GHz',
          jammingDistance: '≥1.5km',
          protectionLevel: '≥IP66'
        },
        labels: {
          detectionDistance: '侦测距离',
          detectionTime: '侦测时间',
          jammingBands: '打击频段',
          jammingDistance: '打击距离',
          protectionLevel: '防护等级'
        }
      },
      TK50: {
        name: 'TK50',
        equipmentIntro: '设备简介',
        coreParams: '核心参数',
        collapse: '收起简介',
        expand: '设备简介',
        expandParams: '核心参数',
        intro: 'TK50凭借其轻量设计实现单人作业，并且能够为不同农作物的多个生产环节提供高效的解决方案，日作业效率可达70公顷。',
      }
    }
  },
  surveyingServices: {
    title: '三维动画服务',
    description: '依托遥感、GIS、无人机航测与三维建模技术，聚焦地理空间可视化与数字场景集成，为城建、市政、应急、环保、交通等行业提供从数据采集、模型构建到动画制作、场景渲染的全流程解决方案。',
    categories: [
      { title: '三维展示', items: ['工程施工模拟', '城市漫游展示', '灾害应急推演'] }
    ]
  },
  uavService: {
    tabs: ['无人机应用', '无人机培训', '无人机表演'],
    applications: {
      categories: [
        { title: '航空测绘', items: ['正射影像', '全景影像', '倾斜模型'] },
        { title: '智能巡检', items: ['自然资源巡查', '人居环境巡查', '电力巡检'] },
        { title: '农业植保', items: ['农业植保'] },
        { title: '物资吊装', items: ['物资吊装'] },
        { title: '应急救援', items: ['消防救援', '洪涝救援', '人员搜救'] }
      ]
    },
    training: {
      categories: [
        { 
          title: '民用无人机驾驶执照（CAAC）培训', 
          description: '民用无人机驾驶执照（CAAC）由中国民航局飞行标准司签发，法律效力高，是无人机行业从业必备证书。高翔地理巨高职业培训学校长期开展CAAC培训，拥有专业持证教学团队，助力学员持证上岗、合规从业。'
        },
        { 
          title: '青少年无人机培训', 
          description: '青少年无人机培训依托专业师资，打造“基础理论+模拟操作+实战应用”阶梯式课程，以特色课堂与实践活动激发青少年科学兴趣。学员参与无人机赛事并取得佳绩，可助力综合素质评价、自主招生与强基计划申报，真正实现“以赛促学、赋能升学”。'
        },
        { 
          title: '无人机技能培训', 
          description: '公司围绕无人机测绘、摄影、吊装、巡检、消防等核心应用领域，打造了一套完整的培训体系，助力学员提升无人机操作技能。'
        }
      ]
    },
    performance: {
      category: '科技表演',
      items: ['飞天魔毯', '龙凤呈祥', '仿生翼蝴蝶', '航模拉烟']
    }
  },
  remoteSensingData: {
    title: '遥感数据服务',
    description: '公司遥感影像数据覆盖邯郸市整个市区，包括房屋建筑、植被类型、土壤墒情、水质参数、地表温度、海水温度等丰富的信息，遥感影像定期更新覆盖，具有历史数据追溯功能。此外，公司可根据不同客户的不同需求，收集不同的信息，从而提供定制化服务。',
    dataServices: {
      title: '数据服务',
      items: ['米级', '亚米级', '多光谱']
    },
    applicationScenarios: {
      title: '应用场景',
      items: ['自然资源监管', '城市违建监管', '建筑形变监测', '地表沉降监测']
    }
  },
  threeDModeling: {
    title: '三维数字化建模服务',
    applicationScenarios: '应用场景',
    roadScene: {
      title: '道路场景',
      description: '将现实中的道路通过数字化技术转化为三维模型，该模型可在道路设计、交通规划、交通管制等领域中得到广泛应用。'
    },
    indoorScene: {
      title: '室内场景',
      description: '基于SLAM或单站点云及照片数据，开展室内场景三维建模。'
    }
  },
  threeDVisualization: {
    title: '三维可视化服务',
    description: '构建基于现实的三维模型效果，让数据展现更为直观和容易理解，提高用户的交互感，三维可视化已经迅速成为信息数字化管理的重要组成部分，被广泛应用到各行业中。',
    relatedCases: '相关案例',
    cases: [
      {
        title: '综合管廊可视化系统建设',
        description: '软件采用三维立体模式仿真地下综合管廊，对管廊主体、管线、设备等三维模型数据进行显示、编辑和存储，集成了对水、电、气、热、通信管道、有害气体浓度、温湿度等数据监测的系统，全方位感知管廊关键设备及环境信息，解读城市能源信息、安全态势，对影响管廊正常运行的故障进行预警，保障其正常运行；监测管廊本体及管网动态，分析采集有效信息，整理历史数据，辅助管理人员做出决策，提高运维效率。'
      },
      {
        title: '河湖可视化',
        description: '智慧大数据综合平台对河湖进行动态监测，及时收集、汇总、分析、处理地理空间信息、跨行业信息等，为河湖的精细化管理提供技术支撑。',
        features: [
          '运用无人机巡查和视频感知，对来往船只进行监管、识别水面漂浮物、对非法采砂、非法排污、非法侵占、非法垂钓、违规游泳等行为及时预警；',
          '安装断面传感器，及时发现化工企业、家畜养殖企业排口等违规行为，对水质、水面实时监测；',
          '建立水雨情可视化遥测站，安装水文传感器和智能AI水尺球机，实时检测水文数据、读取水尺数值，对城市洪涝进行预警。'
        ]
      },
      {
        title: '道路基础设施三维数字管养平台',
        description: '道路基础设施三维数字管养一体化解决方案，包括平台、装备、软件及数据处理服务等。项目针对路网级道路基础设施的类多、量大、面广等问题，做出相应措施。基于现代技术手段，构建道路基础设施三维数字平台，统一各类三维数据标准，实现海量基础设施模型在线管理与可视化显示服务；建设道路资产数字化管理系统和道路巡检管理系统，实现道路资产精准化管理和路面高效化巡检。'
      }
    ]
  },
  systemIntegration: {
    title: '系统集成服务',
    description: '高翔地理以满足客户的需求为出发点，通过软件、硬件与通信技术相结合的方式为用户解决信息处理等问题，综合运用各种信息化技术手段，使各部分之间能够有机协调地工作，从而做到整体效益最大化，达到整体优化的目的。',
    applicationAreas: '应用领域',
    systems: [
      {
        title: '桥梁安全监测系统',
        sections: [
          {
            title: '1.系统介绍',
            content: '桥梁安全监测系统集桥梁结构监测、数据可视化、危险报警、实时视频监控等功能于一体。通过在桥梁上安装各类传感器和监测设备，实时采集桥梁的结构状态和环境参数等数据，一旦发现异常，立即向数据中心报警推送。'
          },
          {
            title: '2.硬件集成',
            content: [
              '监测感知硬件集成：集成高精度位移计和高清视频摄像头，实现桥梁可视化监测，满足"数据监测+可视化管控"双重需求。',
              '终端与报警硬件集成：集成高性能RTU终端，实现感知设备的数据上传。同时，配套集成声光报警器，与监测数据联动，当位移等关键指标超出预警阈值时，自动触发声光报警。',
              '供电系统硬件集成：集成太阳能组件、储能设备，为监测感知设备及报警设备提供清洁、稳定、可持续的电力支持。'
            ]
          },
          {
            title: '3.软件研发',
            content: [
              '平台自主研发：自主开发桥梁安全监测平台，接入位移、视频监测数据，及时掌握桥梁安全状态。',
              '数据智能分析：内置智能分析算法，可对位移数据进行趋势分析、异常识别，当数据超出预警阈值时，自动触发平台预警提示，并联动声光报警器启动报警。',
              '软件适配集成：软件与各类硬件设备兼容适配，解决软件与硬件、软件与通信链路的衔接问题，实现"硬件采集-数据传输-软件分析-预警提示"的全流程自动化运行。'
            ]
          },
          {
            title: '4.通信保障',
            content: [
              '通信链路搭建：定制搭建通信链路，支持4G通信方式，实现监测感知及报警设备与监测平台的对接。',
              '数据安全保障：采用加密传输技术，对敏感信息进行加密，防止数据泄露。同时，优化通信协议，保证数据传输效率。'
            ]
          }
        ]
      },
      {
        title: '智能光纤传感系统',
        sections: [
          {
            title: '1.系统介绍',
            content: '智能光纤传感系统由分布式光纤传感振动探测系统和分布式光纤传感温度监测系统构成，采用人工智能模式识别算法，通过对施加给光纤的多种扰动（温度、振动、应变等）进行实时监测与识别，达到对威胁行为第一时间预警的目的。'
          },
          {
            title: '2.硬件集成',
            content: [
              '探测光缆：包括振动光缆、感温光缆，可根据场景采用表面式、嵌入式、地埋式等多种敷设方式。',
              '分布式光纤线性振动监测主机：沿光缆实时感知、定位并监测沿线振动、扰动与入侵事件。',
              '分布式光纤线性感温探测主机：沿光缆实时监测沿线温度变化、精准定位异常热点。'
            ]
          },
          {
            title: '3.软件研发',
            content: [
              '分布式集中监控：采用分布式架构设计方式，更适合在空间上具有分散特性的监测系统的应用。',
              '丰富的交互方式：基于组态的方式构建监控系统平台，支持客户端监控和Web浏览方式，可与GIS进行数据交互，支持三维展示。',
              '高效的联动机制：采用三级联动机制，大大提高监控系统自动化程度；结合系统强大和全面的集成能力，使联动效率更加灵活高效。',
              '全面的集成支持：基于弱耦合的开放式模块化接口设计，可实现与不同专业系统硬件设备的集成支持。'
            ]
          },
          {
            title: '4.通信保障',
            content: [
              '现场设备通信线路：采用专用线缆实现现场设备间的近距离通信，分别传输视频数据、报警开关信号、设备交互网络数据。',
              '系统组网与通信：通过网络交换机搭建现场局域网，实现现场硬件设备的组网互联。监控中心依托以太网等标准通信接口，实现软件平台与后端处理设备的对接。'
            ]
          }
        ]
      }
    ]
  },
  hvSeries: {
    bannerTitle1: 'TK50',
    bannerTitle2: '农业无人机',
    bannerSlogan: '科技领航，赋能绿色革命',
    modelIntro: 'TK50四轴农业无人飞机有50L负载，全新智能控制系统升级<br>操作更顺畅，更轻便，大流量叶轮泵和水冷式离心喷头<br>喷洒系统和播撒系统可快速更换简单便捷',
    powerTitle: 'TK50 X13 动力系统',
    powerSubtitle: '拉力大，效率高，响应快',
    sprayTitle: '喷洒系统',
    sprayDesc: '采用全新双离心喷头流量大、雾化好、穿透力强。强力穿透植株，冠层厚的果树、叶面叶背都能均匀覆盖',
    spreadingTitle: '播撒系统',
    spreadingDesc: '80L超大容量播撒箱，360°大流量播撒，全新升级锯齿搅拌盘',
    bodyTitle: '机身牢靠 坚固够稳',
    bodyDesc: '智造无限可能，兼顾实用性，耐用性和经济性，便于日常运输及装配',
    highlightsTitle: '亮点展示',
    batteryTitle: '智能电池',
    batterySpec: '18s 30000mah',
    powerCard1Title: '大载重电机',
    powerCard1Desc: '性能提升，拉力提升',
    powerCard2Title: '高强度桨叶',
    powerCard2Desc: '55英寸大桨叶',
    powerCard3Title: '大功率电调',
    powerCard3Desc: '控制更精准',
    spreadImg1: '播撒化肥',
    spreadImg2: '播撒种子',
    spreadImg3: '播撒饵料',
    radar1: '仿地雷达',
    radar2: '避障雷达',
    radar3: '高清摄像头',
    inventoryPowerTitle: '动力清单',
    inventoryFrameTitle: '机架清单',
    propCW: '螺旋桨CW',
    motorCW: '电机CW',
    propHolder: '桨托',
    propCCW: '螺旋桨CCW',
    motorCCW: '电机CCW',
    fuselageAssembly: '机身总成',
    landingGear: '脚架',
    wireRubber: '转臂导线胶',
    waterTank: '水箱',
    carbonArm: '碳纤机臂',
    adapterPlate: '转接件碳纤板',
    gearPad: '脚架垫',
    partsBag: '零件包',
    crossTube: '脚架横管',
    teeJoint: '脚架三通件',
    waterPipe: '水管',
    accessory1Title: '双口径大药箱',
    accessory1Desc: '双开口设计，药剂补充更加快速便捷',
    accessory2Title: '离心喷头',
    accessory2Desc: '极致雾化，均匀覆盖，利用高速旋转离心力，将药液"甩"成微米级均匀雾滴，犹如薄雾弥漫，轻松穿透作物冠层',
    accessory3Title: '大流量叶轮泵',
    accessory3Desc: '高效(大流量)、轻量化、喷洒稳定性、可靠耐用，低维护实现大田作业、果树作业',
    accessory4Title: '称重传感器',
    accessory4Desc: '配置三个承重感应器，实时反馈药箱情况，安心作业',
    pumpPressure: '水泵最大压力',
    pumpValue: '0.8mpa',
    nozzle: '喷头',
    nozzleValue: '离心喷头',
    sprayFlow: '喷洒流量',
    sprayFlowValue: '12L/min',
    sprayWidth: '喷幅',
    sprayWidthValue: '6-10m',
    tankLoad: '药箱载荷',
    tankLoadValue: '50L',
    workHours: '时效作业',
    workHoursValue: '70亩',
    flyControlModule: '一体式飞控模块',
    flyControlModuleDesc: '集成度高，快捷安装，防水防尘、提供便捷、高效的使用体验',
    armSensor: '机臂传感器',
    armSensorDesc: '采用按压式锁紧模式，双重保险，防止飞行中机臂松懈掉落',
    copperBoard: '厚铜电路板',
    copperBoardDesc: '高强度过流，特制防水胶，坚固耐用，适应各种环境要求，提供长期稳定保障',
    trussStructure: '桁架结构',
    trussStructureDesc: '强度坚硬，重量轻，共振小，坚固牢靠，不易变形断裂'
  },
  contactUs: {
    title: '联系我们',
    titleEnglish: 'Contact us',
    handanCenter: '邯郸生产中心',
    handanPhone: '电话：0310-5300963',
    handanAddress: '地址：河北省邯郸市丛台区荀子大街5号',
    wuanCenter: '武安科技中心',
    wuanPhone: '电话：19930806111',
    wuanAddress: '河北省邯郸市武安市工业园区纬三路创业服务中心四期4号楼第6层',
    branchAddresses: '分公司地址信息',
    branchCities: ['石家庄', '邢台', '临漳', '邱县', '广平', '曲周'],
    branchNames: ['石家庄分公司', '邢台分公司', '临漳分公司', '邱县分公司', '广平分公司', '曲周分公司'],
    branchPhones: ['0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963', '0310-5300963'],
    branchAddress: '河北省邯郸市邯山区光明南大街108号'
  }
}